/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as types from './types';

const currencies = (state = [], { type, payload }) => {
  switch (type) {
    case types.FETCH_CURRENCY.SUCCESS:
      return payload;
    default:
      return state;
  }
};

const configError = (state = false, { type }) => {
  switch (type) {
    case types.FETCH_CURRENCY.ERROR:
      return true;
    default:
      return state;
  }
};

export const settingsState = {
  touchpos_out_of_stock_warning: '',
  pos_languages: [
    {
      name: 'Arabic, Saudi Arabia',
      code: 'ara-sa',
    },
    {
      name: 'Chinese Simplified',
      code: 'zh-s',
    },
    {
      name: 'Danish',
      code: 'dan',
    },
    {
      name: 'Dutch',
      code: 'dut',
    },
    {
      name: 'English, Australia',
      code: 'eng-au',
    },
    {
      name: 'English, United States',
      code: 'eng',
    },
    {
      name: 'Estonian',
      code: 'est',
    },
    {
      name: 'Faroese',
      code: 'fao',
    },
    {
      name: 'Finnish',
      code: 'fin',
    },
    {
      name: 'French',
      code: 'fre',
    },
    {
      name: 'German',
      code: 'gere',
    },
    {
      name: 'Greek',
      code: 'gre',
    },
    {
      name: 'Indonesian',
      code: 'ind',
    },
    {
      name: 'Italian',
      code: 'ita',
    },
    {
      name: 'Latvian',
      code: 'lat',
    },
    {
      name: 'Lithuanian',
      code: 'lit',
    },
    {
      name: 'Norwegian',
      code: 'nor',
    },
    {
      name: 'Polish',
      code: 'pol',
    },
    {
      name: 'Russian',
      code: 'rus',
    },
    {
      name: 'Spanish',
      code: 'spa',
    },
    {
      name: 'Swedish',
      code: 'swe',
    },
    {
      name: 'Thai',
      code: 'tha',
    },
    {
      name: 'Turkish',
      code: 'tur',
    },
    {
      name: 'Vietnamese',
      code: 'vie',
    },
  ],
};

const settings = (state = settingsState, { type, payload }) => {
  switch (type) {
    case types.SET_SETTINGS.SUCCESS:
    case types.SAVE_SETTINGS.SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default combineReducers({ currencies, configError, settings });
